// TOP LEVEL IMPORTS
import gql from 'graphql-tag';
import organizationFragment from 'ApolloClient/Fragments/organizationFragment';
import customDashboardFragment from 'ApolloClient/Fragments/customDashboardFragment';

export default gql`
  query organizationById($orgId: ID!) {
    organizationById(orgId: $orgId) {
      ...organizationFragment
      dashboards {
        ...customDashboardFragment
      }
      allowedMSAs {
        _id
        msaName
      }
      numberOfMSAs
      allowedStates
      msaMode
      teamMembers {
        _id
        emails {
          address
        }
        profile {
          firstName
          lastName
        }
      }
    }
  }
  ${organizationFragment}
  ${customDashboardFragment}
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/organizationById.js